import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin, scAxios } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroupFunctional from "../RadioGroupFunctional";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import thanas from "../../assets/data/thana.json";
import { error } from "jquery";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const BirthCertificate = () => {
  const [enableBtn, setEnableBtn] = useState(true);
  const [rawDate, setRawDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    newBornId: "",
    slNo: "",
    sex: "Male",
    date: "",
    relation: "",
    mothersId: "",
    mothersName: "",
    mothersNationality: "",
    mothersReligion: "",
    fathersName: "",
    fathersNationality: "",
    fathersReligion: "",
    presentAddress: "",
    permanentAddress: "",
  });
  // const da=formData.date
  // const newDate= da.toString().split(" ",4)
  // const newSting=(newDate.toString().split(" "))
  // console.log(formData)
  useEffect(() => {
    if (
      formData.newBornId &&
      formData.slNo &&
      formData.date &&
      formData.relation &&
      formData.mothersId &&
      formData.mothersName &&
      formData.mothersNationality &&
      formData.mothersReligion &&
      formData.fathersName &&
      formData.fathersNationality &&
      formData.fathersReligion &&
      formData.presentAddress &&
      formData.permanentAddress
    ) {
      setEnableBtn(false);
    } else {
      setEnableBtn(true);
    }
  }, [
    formData.newBornId,
    formData.slNo,
    formData.date,
    formData.relation,
    formData.mothersId,
    formData.mothersName,
    formData.mothersNationality,
    formData.mothersReligion,
    formData.fathersName,
    formData.fathersNationality,
    formData.fathersReligion,
    formData.presentAddress,
    formData.permanentAddress,
  ]);
  const sexList = [
    { id: "1", label: "MALE", value: "Male" },
    { id: "2", label: "FEMALE", value: "Female" },
    { id: "3", label: "OTHERS", value: "Others" },
  ];
  const relation = [
    { id: "1", label: "FATHER", value: "Father" },
    { id: "2", label: "SPOUSE", value: "Spouse" },
    { id: "3", label: "GUARDIAN", value: "Guardian" },
  ];

  // const formatedDate =typeof rawDate==="object"?rawDate.slice(0, 4).join(" "):""
  useEffect(() => {
    if (typeof rawDate === "object") {
      const newObj = new Date(rawDate).toString();
      const formatedDate = newObj.split(" ").slice(0, 4).join(" ");
      setFormData({
        ...formData,
        date: formatedDate,
      });
    }
  }, [rawDate]);

  const handleSex = (value) => {
    setFormData({ ...formData, sex: value });
  };
  const handleRelation = (value) => {
    setFormData({ ...formData, relationWithDeceased: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const postData = {
      type: "birth_certificate",
      form_data: {
        ...formData,
      },
    };
    setLoading(true);
    try {
      const req = scAxiosAdmin
        .post("/form_submission", postData, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            toast.success(
              "Your request is received, you will be notified soon!"
            );
            setLoading(false);
          } else {
            toast.error("Ops something went wrong!");
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDateChange = (date) => {
    setRawDate(date);
  };

  return (
    <div>
      <SEO
        title="Birth Certificate | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Birth Certificate "
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <section className="banner-hero">
          <img
            src="/static/media/banner-profile.f160a4c1.jpg"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section className="prof-dr py-5">
          <div className="container">
            <div className="box-of-about border-part py-4">
              <div className="container">
                <div className="row gy-4">
                  <div className="col-md-12">
                    <h3
                      className="text-center mb-5"
                      style={{
                        color: "#0C807D",
                        fontWeight: "700",
                      }}
                    >
                      Request for Birth Certificate
                    </h3>
                  </div>
                  <div className="col-md-12">
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="newBornId">Newborn ID No:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="newBornId"
                            name="newBornId"
                            required
                            value={formData.newBornId}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                newBornId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="slNo">SL. NO.:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="slNo"
                            name="slNo"
                            value={formData.slNo}
                            required
                            onChange={(e) =>
                              setFormData({ ...formData, slNo: e.target.value })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="sex">Sex:</label>
                          <RadioGroupFunctional
                            name="sex"
                            radioOptions={sexList}
                            defaultSelected="Male"
                            onChange={handleSex}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="date">Date of Birth: </label>

                          <br />

                          <DatePicker
                            className="form-control"
                            selected={rawDate}
                            value={rawDate}
                            onChange={(date) => handleDateChange(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD/MM/YYYY"
                            showDateMonthYearPicker
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label htmlFor="relation">
                            Relation of Newborn With Patient:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="relation"
                            name="relation"
                            value={formData.relation}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                relation: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mothersId">Mother's ID No.:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="mothersId"
                            name="mothersId"
                            value={formData.mothersId}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mothersId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mothersName">Mother's Name:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="mothersName"
                            name="mothersName"
                            value={formData.mothersName}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mothersName: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mothersNationality">
                            Nationality:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="mothersNationality"
                            name="mothersNationality"
                            value={formData.mothersNationality}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mothersNationality: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mothersReligion">Religion:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="mothersReligion"
                            name="mothersReligion"
                            value={formData.mothersReligion}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mothersReligion: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="fathersName">Father's Name:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fathersName"
                            name="fathersName"
                            value={formData.fathersName}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                fathersName: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="fathersNationality">
                            Nationality:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fathersNationality"
                            name="fathersNationality"
                            value={formData.fathersNationality}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                fathersNationality: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="fathersReligion">Religion:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fathersReligion"
                            name="fathersReligion"
                            value={formData.fathersReligion}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                fathersReligion: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="presentAddress">
                            Present Address:
                          </label>
                          <textarea
                            type="textarea"
                            className="form-control"
                            id="presentAddress"
                            name="presentAddress"
                            value={formData.presentAddress}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                presentAddress: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="permanentAddress">
                            Permanent Address:
                          </label>
                          <textarea
                            type="textarea"
                            className="form-control"
                            id="permanentAddress"
                            name="permanentAddress"
                            value={formData.permanentAddress}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                permanentAddress: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <button
                        className="buts"
                        type="submit"
                        disabled={enableBtn}
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                  {/* <div className="col-md-4 bg-white p-0">
                      <a href="tel:10666">
                        <h1
                          className="text-center category-list-link open-cat-list"
                          style={{ backgroundColor: "red" }}
                        >
                          Call Emergency Line <br />
                          <h1>
                            {" "}
                            <i className="fa fa-phone mt-2 "></i>
                            10666
                          </h1>
                        </h1>
                      </a>
                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default BirthCertificate;



// WEBPACK FOOTER //
// ./src/component/frontend/BirthCertificate.js